import { Radio, RadioChangeEvent, Row } from "antd";
import { SearchWithClear } from "../../../../components/SearchWithClear";
import { useCallback, useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";

type SearchFilterProps = {
  isLoading: boolean;
  request: any;
};

const OPTIONS = [
  {
    value: "contractNumberCrossReference",
    label: "Account #",
    placeholder: "Search by Account or X-Ref numbers",
  },
  {
    value: "primaryPayerFullName",
    label: "Buyer",
    placeholder: "Search by Buyer name",
  },
  {
    value: "primaryPayeeFullName",
    label: "Seller",
    placeholder: "Search by Seller name",
  },
  {
    value: "propertyAddress",
    label: "Address",
    placeholder: "Search by Property address",
  },
];

export const SearchFilter = ({ isLoading, request }: SearchFilterProps) => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [__, setSearchParams] = useSearchParams();

  const [selectedPlaceholder, setSelectedPlaceholder] = useState<any>(
    OPTIONS[0],
  );

  const [search, setSearch] = useState<string>("");

  useEffect(() => {
    if (request.contractNumberCrossReference) {
      setSearch(request.contractNumberCrossReference);
    }
    if (request.primaryPayerFullName) {
      setSearch(request.primaryPayerFullName);
      setSelectedPlaceholder(OPTIONS[1]);
    }
    if (request.primaryPayeeFullName) {
      setSearch(request.primaryPayeeFullName);
      setSelectedPlaceholder(OPTIONS[2]);
    }
    if (request.propertyAddress) {
      setSearch(request.propertyAddress);
      setSelectedPlaceholder(OPTIONS[3]);
    }
  }, [request]);

  const onSearch = useCallback(
    (value: string, placeholder?: any) => {
      const params = { ...request, pageNumber: 1 };

      delete params.contractNumberCrossReference;
      delete params.propertyAddress;
      delete params.primaryPayerFullName;
      delete params.primaryPayeeFullName;

      params[placeholder || selectedPlaceholder.value] = value;

      !value && setSearch("");

      setSearchParams(params);
    },
    [request, selectedPlaceholder, setSearchParams],
  );

  const onRadioChange = useCallback(
    (e: RadioChangeEvent) => {
      const val = e.target.value;

      const option = OPTIONS.find((item: any) => item.value === val);

      setSelectedPlaceholder(option);

      if (search) {
        onSearch(search, val);
      }
    },
    [onSearch, search],
  );

  return (
    <Row className="d-block">
      <SearchWithClear
        isLoading={isLoading}
        search={search}
        setSearch={onSearch}
        placeholder={selectedPlaceholder.placeholder}
      />
      <Row className="mt-2">
        <Radio.Group
          options={OPTIONS}
          onChange={onRadioChange}
          value={selectedPlaceholder.value}
          disabled={isLoading}
        />
      </Row>
    </Row>
  );
};
